/**
 * Review Slider Component
 * Manages Swiper slider for customer reviews
 */
class ReviewSlider {
    constructor(element) {
        this.element = element;
        this.swiper = null;
        this.init();
    }

    /**
     * Initialize the slider
     */
    init() {
        if (!this.element) {
            console.warn('ReviewSlider: Element not found');
            return;
        }

        this.initSwiper();
    }

    /**
     * Initialize Swiper instance
     */
    initSwiper() {
        const swiperContainer = this.element.querySelector('.reviews-swiper');
        
        if (!swiperContainer) {
            console.warn('ReviewSlider: Swiper container not found');
            return;
        }

        this.swiper = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                },
                1400: {
                    slidesPerView: 6,
                    spaceBetween: 20,
                }
            }
        });
    }

    /**
     * Destroy the slider
     */
    destroy() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    }

    /**
     * Update the slider (useful for dynamic content)
     */
    update() {
        if (this.swiper) {
            this.swiper.update();
        }
    }

    /**
     * Get current slide index
     */
    getCurrentSlide() {
        return this.swiper ? this.swiper.activeIndex : 0;
    }

    /**
     * Go to specific slide
     */
    goToSlide(index) {
        if (this.swiper) {
            this.swiper.slideTo(index);
        }
    }
}

/**
 * Initialize Review Sliders
 */
document.addEventListener('DOMContentLoaded', function() {
    const reviewSliderElements = document.querySelectorAll('[data-review-slider]');
    
    if (reviewSliderElements.length === 0) {
        return; // Exit if no review slider elements found
    }

    // Initialize each review slider
    reviewSliderElements.forEach(element => {
        new ReviewSlider(element);
    });
});

// Export for potential external use
if (typeof module !== 'undefined' && module.exports) {
    module.exports = ReviewSlider;
} else if (typeof window !== 'undefined') {
    window.ReviewSlider = ReviewSlider;
}